import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { createCustomFetchBaseQuery } from "../baseQuery";
import { update } from "lodash";

export const authApi = createApi({
  reducerPath: 'auth',
  baseQuery: createCustomFetchBaseQuery(),
  endpoints: (builder) => ({
    
    login: builder.mutation({
      query: (login) => ({
        url: `login`,
        method: 'POST',
        body: login,
      }),
    }),

    register: builder.mutation({
      query: (register) => ({
        url: `/regular-user/signup`,
        method: 'POST',
        body: register,
      }),
    }),

    changePassword: builder.mutation({
      query: (data) => ({
        url: `changePassword`,
        method: 'PUT',
        body: data,
      }),
    }),

    resetpassword: builder.mutation({
      query: (data) => ({
        url: `resetpassword`,
        method: 'PUT',
        body: data,
      }),
    }),

     resetpasswordNewUser : builder.mutation({
      query: (data) => ({
        url: `resetpassword/newUser`,
        method: 'PUT',
        body: data,
      }),
    }),

    verifyEmail: builder.mutation({
      query: (data) => ({
        url: `/regular-user/verify-otp`,
        method: 'PUT',
        body: data,
      }),
    }),

    validatePin: builder.mutation({
      query: (data) => ({
        url: `validatepin`,
        method: 'PUT',
        body: data,
      }),
    }),

    forgotPassword: builder.mutation({
      query: (data) => ({
        url: `forgetpassword`,
        method: 'PUT',
        body: data,
      }),
    }),

    updateProfile: builder.mutation({
      query: (data) => ({
        url: `updateprofile`,
        method: 'PUT',
        body: data,
      }),
    }),

    resendOtp: builder.mutation({
      query: (data) => ({
        url: `otp-resend`,
        method: 'PUT',
        body: data,
      }),
    }),

    regularUserResendOtp: builder.mutation({
      query: (data) => ({
        url: `/regular-user/otp-resend`,
        method: 'PUT',
        body: data,
      }),
    }),

    deleteAccount: builder.mutation({
      query: () => ({
        url: `deleteAccount`,
        method: 'DELETE',
      }),
    }),
    
    socialLogin: builder.mutation({
      query: (data) => ({
        url: `social/login`,
        method: 'POST',
        body: data,
      }),
    }),


  }),
});

export const {
 useForgotPasswordMutation,
 useLoginMutation,
 useRegisterMutation,
 useChangePasswordMutation,
 useVerifyEmailMutation,
 useValidatePinMutation,
 useResetpasswordMutation,
  useUpdateProfileMutation,
  useDeleteAccountMutation,
  useResendOtpMutation,
  useResetpasswordNewUserMutation,
  useSocialLoginMutation,
  useRegularUserResendOtpMutation,
} = authApi;